var $5e9e2094eb0f96cf$exports = {};
$5e9e2094eb0f96cf$exports = {
    "removeButtonLabel": `\u{5D4}\u{5E1}\u{5E8}`,
    "removeDescription": `\u{5DC}\u{5D7}\u{5E5} \u{5E2}\u{5DC} \u{5DE}\u{5D7}\u{5E7} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5EA}\u{5D2}.`
};


export {$5e9e2094eb0f96cf$exports as default};
//# sourceMappingURL=he-IL.mjs.map
